// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"de0127f4","316":"14b7289e","393":"2ed119e1","396":"b6db03e5","447":"7b704ae1","453":"c6c9ab4d","455":"733b0807","474":"e4890ab1","967":"3fb072f4","970":"f003d1f7","977":"2a270f74"}[chunkId] + ".chunk.js";
};